import { render, staticRenderFns } from "./TabPending.vue?vue&type=template&id=3667c95e"
import script from "./TabPending.vue?vue&type=script&lang=js"
export * from "./TabPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports